export function _addShapeToData(data, command) {
    const localData = { ...data };
    command.do(localData.shapes);
    return localData;
}
